
import { Ref } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Trash2, Upload, UserRound } from "lucide-react";

interface ProfileImageSectionProps {
  profileImage: string | null;
  fileInputRef: Ref<HTMLInputElement>;
  onUploadClick: () => void;
  onImageUpload?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDeleteImage?: () => void;
}

export const ProfileImageSection = ({ 
  profileImage, 
  fileInputRef, 
  onUploadClick,
  onImageUpload,
  onDeleteImage
}: ProfileImageSectionProps) => {
  const handleAvatarClick = () => {
    onUploadClick();
  };

  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="relative">
        <Avatar 
          className="w-24 h-24 border-2 border-gebeya-pink cursor-pointer hover:opacity-90 transition-all"
          onClick={handleAvatarClick}
        >
          {profileImage ? (
            <AvatarImage 
              src={profileImage} 
              alt="Profile" 
              className="object-cover"
            />
          ) : (
            <AvatarFallback 
              className="bg-white"
            >
              <div className="flex items-center justify-center w-full h-full">
                <UserRound className="w-12 h-12 text-gebeya-pink" strokeWidth={1.5} />
              </div>
            </AvatarFallback>
          )}
        </Avatar>
        
        {profileImage && onDeleteImage && (
          <button 
            onClick={(e) => {
              e.stopPropagation();
              onDeleteImage();
            }}
            className="absolute -top-2 -right-2 bg-red-500 text-white p-1 rounded-full hover:bg-red-600 transition-colors"
            title="Delete image"
            type="button"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>
      
      <Button
        type="button"
        variant="gradient"
        onClick={onUploadClick}
        className="flex items-center gap-2"
      >
        <Upload className="w-4 h-4" />
        Upload Profile Picture
      </Button>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={onImageUpload}
      />
    </div>
  );
};
